
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/[platform]-vs-[platform]",
      function () {
        return require("private-next-pages/compare/[platform]-vs-[platform].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/[platform]-vs-[platform]"])
      });
    }
  